import { ErrorBlock } from 'antd-mobile'
/**
 * 错误布局组件 - 包装应用内容并在捕获到错误时显示错误页面
 * @param children 子组件内容
 */
export function ErrorLayout() {
  return (
    <div className="flex items-center justify-center">
      <ErrorBlock status="default" fullPage />
    </div>
  )
}
